import React from "react";
import {AccountBalanceWallet, Campaign, EmojiEvents, Help, Message, NoteOutlined} from '@mui/icons-material';
import {ARTICLE_LIST_ROUTE, COUPON_LIST_ROUTE, COUPON_REDEEM_ROUTE, SHOPS_LIST_ROUTE, SPONSORED_NOTIFICATIONS_ROUTE, VENDOR_HOME_ROUTE, WALLET_ROUTE} from "./vendors";
import HomeIcon from '@mui/icons-material/Home';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import {Trans} from "react-i18next";

const home = {
    name: <Trans i18nKey="vendorHome"/>,
    url: VENDOR_HOME_ROUTE,
    icon: <HomeIcon/>
};

const couponRedeem = {
    name: <Trans i18nKey="couponRedeem"/>,
    url: COUPON_REDEEM_ROUTE,
    icon: <DashboardIcon/>
};

// Intestazioni di gruppo: la Sidebar le riconosce da `group` e le disegna come
// etichetta invece che come voce cliccabile. Servono a raggruppare il menu per
// intento (cosa voglio fare) invece che per entita'.
const groupDaily = {group: true, id: 'daily', name: <Trans i18nKey="vendorGroupDaily"/>};
const groupPromote = {group: true, id: 'promote', name: <Trans i18nKey="vendorGroupPromote"/>};
const groupShop = {group: true, id: 'shop', name: <Trans i18nKey="vendorGroupShop"/>};

const shops = {
    name: <Trans i18nKey="shops"/>,
    url: SHOPS_LIST_ROUTE,
    icon: <ShoppingCartIcon/>
};

const articles = {
    name: <Trans i18nKey="awardsCommunity"/>,
    url: ARTICLE_LIST_ROUTE,
    icon: <EmojiEvents/>
};

const couponList = {
    name: <Trans i18nKey="voucher"/>,
    url: COUPON_LIST_ROUTE,
    icon: <NoteOutlined/>
};

const wallet = {
    name: <Trans i18nKey="wallet"/>,
    url: WALLET_ROUTE,
    icon: <AccountBalanceWallet/>
};

const help = {
    name: <Trans i18nKey="helpMenuTab"/>,
    url: "/help",
    icon: <Help/>
};

const messages = {
    name: <Trans i18nKey="messages"/>,
    url: "/messages",
    icon: <Message/>
};

const sponsoredNotifications = {
    name: <Trans i18nKey="sponsoredNotifications"/>,
    url: SPONSORED_NOTIFICATIONS_ROUTE,
    icon: <Campaign/>
};

export default {
    home,
    groupDaily,
    groupPromote,
    groupShop,
    couponRedeem,
    shops,
    articles,
    couponList,
    sponsoredNotifications,
    wallet,
    help,
    messages
};
